import React from 'react';
import PropTypes from 'prop-types';
import {
  Icon,
  Tooltip,
  Select,
  Row,
  Col,
  Button,
  Radio,
  Input,
  InputNumber,
  Table,
  Popover,
  Form,
  Divider,
  notification,
} from 'antd';
import { inject, observer } from 'mobx-react';

const { Option } = Select;
const InputGroup = Input.Group;

@inject('dataStore')
@inject('commonStore')
@observer
class MapMenu extends React.Component {
  static propTypes = {
    commonStore: PropTypes.object.isRequired,
    dataStore: PropTypes.object.isRequired,
  };

  state = {
    customMihPoe: {
      value: null,
    },
  };

  componentWillMount() {
    const { dataStore } = this.props;

    dataStore.initialDatasetName = new URLSearchParams(window.location.search).get("dataset");
    dataStore.setCurrentMaptype('hazard');
    dataStore.getDatasetList();
  }

  // onDatasetChange = value => {
  //   this.props.dataStore.setCurrentDataset(value);
  // };

  // onMaptypeChange = e => {
  //   this.props.dataStore.setCurrentMaptype(e);
  // };

  // onStatisticChange = e => {
  //   this.props.dataStore.setCurrentStatistic(e);
  // };

  // onMihPoeChange = e => {
  //   this.props.dataStore.setCurrentMihPoe(e);
  // };

  onMaptypeChange = e => {
    const maptype = e.target.value;
    this.props.dataStore.setCurrentMaptype(maptype);
    if (maptype === 'hazard') {
      this.props.dataStore.setCurrentMihPoe('2475');
    } else {
      this.props.dataStore.setCurrentMihPoe('1');
    }
  };

  onStatisticChange = e => {
    console.log(`onStatisticChange. new value: ${e.target.value}`)
    const statistic = e.target.value;
    this.props.dataStore.setCurrentStatistic(statistic);
  };


  onDatasetChange = e => {
    const dataset = e;
    /* SERGIO_AUTH_ORIG
    var datasetName = this.props.dataStore.getDatasetNameById((datasetName) => {
      window.location.href = `/interactive-map?dataset=${datasetName}`
    },  parseInt(dataset)); */

    /* SERGIO_AUTH_NEW
    var datasetName = this.props.dataStore.getDatasetNameById((datasetName) => {
      window.location.href = `/?dataset=${datasetName}`
    },  parseInt(dataset)); */

    var datasetName = this.props.dataStore.getDatasetNameById((datasetName) => {
      window.location.href = `/?dataset=${datasetName}`
    },  parseInt(dataset));

    // const dataset = e;
    // this.props.dataStore.setCurrentDataset(dataset);
  };

  onMihPoeChange = e => {
    const mihPoe = e;
    this.props.dataStore.setCurrentMihPoe(mihPoe);
  };

  onMihPoeEnter = e => {
    if (this.props.dataStore.currentMaptype === 'hazard') {
      if (e.keyCode === 13) {
        if (e.target.value >= 100 && e.target.value <= 100000) {
          const mihPoe = e.target.value;
          this.props.dataStore.setCurrentMihPoe(mihPoe);
        }
      }
    } else if (e.keyCode === 13) {
      if (e.target.value >= 0.5 && e.target.value <= 50) {
        const mihPoe = e.target.value;
        this.props.dataStore.setCurrentMihPoe(mihPoe);
      }
    }
  };

  handleCustomMihPoeChange = value => {
    function validateCustomMihPoe(customMihPoe, currentMapType) {
      if (currentMapType === 'hazard') {
        if (
          (customMihPoe >= 100 && customMihPoe <= 100000) ||
          customMihPoe === '' ||
          typeof customMihPoe === 'undefined'
        ) {
          return {
            validateStatus: 'success',
            errorMsg: null,
          };
        }
        return {
          validateStatus: 'error',
          errorMsg: '*Enter between 100 and 100000!',
        };
      } else if (currentMapType === 'probability') {
        if ((customMihPoe >= 0.5 && customMihPoe <= 50) || customMihPoe === '' || typeof customMihPoe === 'undefined') {
          return {
            validateStatus: 'success',
            errorMsg: null,
          };
        }
        return {
          validateStatus: 'error',
          errorMsg: '*Enter between 0.5 and 50!',
        };
      }
    }
    this.setState({
      customMihPoe: {
        ...validateCustomMihPoe(value, this.props.dataStore.currentMaptype),
        value,
      },
    });
  };

  handleExportCurves = () => {
    notification.warning({
      message: 'Export Curves',
      description: 'Files are being generated, it can take some time. Please wait.',
      duration: 0,
    });
    
    this.props.dataStore.exportCurves(this.props.dataStore.currentDataset).then(() => {
      notification.destroy();
      notification.success({
        message: 'Export Curves',
        description: 'Curves have been successfully exported!',
      });
    });
  };

  handleExportMapMenuClick   = () => {
    notification.warning({
      message: 'Export Maps',
      description: 'Files are being generated, it can take some time. Please wait.',
      duration: 0,
    });

    this.props.dataStore.exportMaps(this.props.dataStore.currentDataset).then(() => {
      notification.destroy();
      notification.success({
        message: 'Export Maps',
        description: 'Maps have been successfully exported!',
      });
    });
  };

  render() {
    const { commonStore, dataStore } = this.props;

    const currentSettingsData = [
      {
        key: '1',
        parameter: 'Dataset',
        // value: dataStore.datasetList.map(dataset => dataset.name)[dataStore.currentDataset - 1],
        value: dataStore.currentDatasetName,
      },
      {
        key: '2',
        parameter: 'Map Type',
        value: dataStore.currentMaptype,
      },
      {
        key: '3',
        parameter: 'Statistics',
        // value: dataStore.currentStatistic,
        value: dataStore.currentStatisticLabel,
      },
      {
        key: '4',
        parameter: dataStore.currentMaptype === 'hazard' ? 'ARP' : 'MIH',
        value: dataStore.currentMihPoe + (dataStore.currentMaptype === 'hazard' ? ' yr' : ' m'),
      },
      {
        key: '5',
        parameter: 'Exposure Time',
        value: '50 years',
      },
    ];
    // SERGIO_AUTH_ORIG  if (commonStore.currentRoute === '/interactive-map') {
    // SERGIO_AUTH_NEW if (commonStore.currentRoute === '/') {
    if (commonStore.currentRoute === '/') {
      const { customMihPoe } = this.state;
      // @ts-ignore
      // @ts-ignore
      return (
        <div>
          <div className="sidebar-menu__parameters">
            <h4>
              Dataset&nbsp;
              <Tooltip title="Please select the dataset to be loaded.">
                <Icon type="question-circle-o" />
              </Tooltip>
            </h4>
            <Row type="flex" justify="center" gutter={5}>
              <Col>
                <Select
                  // defaultValue="tsumaps-neam"
                  // value={dataStore.datasetList[0].name}
                  // value={dataStore.datasetList.currentDatasetName}
                  value={dataStore.currentDatasetName}
                  onChange={this.onDatasetChange}
                  // onChange={window.location.href = `/interactive-map`}
                  style={{
                    width: 330,
                  }}
                >
                  {dataStore.datasetList.map(d => <Option key={d.id}>{d.name}</Option>)}
                </Select>
              </Col>
              {/* <Col>
                <Link to="/submit-dataset">
                  <Button type="primary" shape="circle" icon="plus" />
                </Link>
              </Col> */}
            </Row>
            <Divider />
            <Radio.Group size="small" defaultValue="hazard" onChange={this.onMaptypeChange} buttonStyle="solid">
              <Radio.Button style={{ width: 165 }} value="hazard">
                Hazard Map
              </Radio.Button>
              <Radio.Button style={{ width: 165 }} value="probability">
                Probability Map
              </Radio.Button>
            </Radio.Group>
            <Divider />
            <h4>
              Statistics&nbsp;
              <Tooltip title="Colored circles are created according to selected statistics.">
                <Icon type="question-circle-o" />
              </Tooltip>
              <Popover
                content={
                  <div>
                    <b>PoE:</b> Probability of Exceedance
                    <br />
                    <b>MIH:</b> Maximum Inundation Height
                    <br />
                    <b>ARP:</b> Avarage Return Period
                    <br />
                    <b>p02:</b> 2nd Percentile of the Epistemic Uncertainty
                    <br />
                    <b>p16:</b> 16th Percentile of the Epistemic Uncertainty
                    <br />
                    <b>p50:</b> 50th Percentile of the Epistemic Uncertainty
                    <br />
                    <b>p84:</b> 84th Percentile of the Epistemic Uncertainty
                    <br />
                    <b>p98:</b> 98th Percentile of the Epistemic Uncertainty
                  </div>
                }
                title="Abbreviations"
                trigger="click"
              >
                <Button style={{ float: 'right' }} size="small" type="default">
                  Abbreviations
                </Button>
              </Popover>
            </h4>
            <Radio.Group onChange={this.onStatisticChange} defaultValue="mean">
              <Radio value="mean">Mean</Radio>
              <Radio value="p02">p02</Radio>
              <Radio value="p16">p16</Radio>
              <Radio value="p50">p50</Radio>
              <Radio value="p84">p84</Radio>
              <Radio value="p98">p98</Radio>
            </Radio.Group>
            <Divider />
            <div>
              <h4>
                {dataStore.currentMaptype === 'hazard' ? 'MIH for given ARPs' : 'PoE for given MIHs'}&nbsp;
                <Tooltip title="You can select from pick list, or enter a custom value.">
                  <Icon type="question-circle-o" />
                </Tooltip>
              </h4>
              <Form>
                <InputGroup compact>
                  {dataStore.currentMaptype === 'hazard' ? (
                    <Form.Item style={{ marginBottom: 0 }}>
                      <Select
                        style={{ width: 100 }}
                        size="small"
                        onChange={this.onMihPoeChange}
                        value={this.props.dataStore.currentMihPoe}
                      >
                        <Option value="475">475yr</Option>
                        <Option value="975">975yr</Option>
                        <Option value="2475">2475yr</Option>
                        <Option value="4975">4975yr</Option>
                        <Option value="9975">9975yr</Option>
                      </Select>
                    </Form.Item>
                  ) : (
                    <Form.Item
                      style={{
                        marginBottom: 0,
                      }}
                    >
                      <Select
                        style={{ width: 100 }}
                        size="small"
                        onChange={this.onMihPoeChange}
                        value={this.props.dataStore.currentMihPoe}
                      >
                        <Option value="1">1m</Option>
                        <Option value="2">2m</Option>
                        <Option value="5">5m</Option>
                        <Option value="10">10m</Option>
                        <Option value="20">20m</Option>
                      </Select>
                    </Form.Item>
                  )}
                  <Form.Item
                    validateStatus={customMihPoe.validateStatus}
                    help={customMihPoe.errorMsg}
                    style={{
                      marginBottom: 0,
                    }}
                  >
                    <InputNumber
                      style={{ width: 220, marginLeft: 10 }}
                      placeholder={
                        dataStore.currentMaptype === 'hazard' ? 'Custom ARP (Press ↵)' : 'Custom MIH (Press ↵)'
                      }
                      size="small"
                      min={dataStore.currentMaptype === 'hazard' ? 100 : 0.5}
                      max={dataStore.currentMaptype === 'hazard' ? 100000 : 50}
                      onChange={this.handleCustomMihPoeChange}
                      onKeyDown={this.onMihPoeEnter}
                    />
                  </Form.Item>
                </InputGroup>
              </Form>
            </div>
          </div>

          <div className="sidebar-menu__currentsettings">
            <Table
              style={{
                backgroundColor: 'var(--primary-color)',
              }}
              size="small"
              title={() => (
                <span
                  style={{
                    border: '0',
                    color: 'white',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  Active Map Summary
                </span>
              )}
              pagination={false}
              columns={[
                {
                  title: 'Parameter',
                  dataIndex: 'parameter',
                  key: 'parameter',
                  align: 'center',
                  render: text => <span style={{ color: 'white', fontWeight: 800 }}>{text}</span>,
                },
                {
                  title: 'Value',
                  dataIndex: 'value',
                  key: 'value',
                  align: 'center',
                  render: text => <span style={{ color: 'white', fontWeight: 800 }}>{text}</span>,
                },
              ]}
              dataSource={currentSettingsData}
              bordered
              footer={() => (
                <span style={{ fontSize: '10px', fontStyle: 'italic', display: 'flex', justifyContent: 'center' }}>
                  Map produced using the <b>&nbsp;{dataStore.currentStatisticLabel}&nbsp;</b>
                  {dataStore.currentStatistic === 'mean' ? '' : 'percentile'} of the Epistemic Uncertainty.
                </span>
              )}
            />
          </div>
          <Row gutter={5} style={{ margin: '0px 10px 10px' }}>
            <Col span={8}>
              {/* <Button
                onClick={this.handleExportMapMenuClick}
                className="sidebar-menu__exportmap"
                loading={dataStore.loadingExportMaps}
                type="primary"
                icon="picture"
                size="small"
              >
                Export Map
              </Button> */}
            </Col>
            <Col span={8}>
              {/* <Button
                onClick={this.handleExportCurves}
                loading={dataStore.loadingExportCurves}
                className="sidebar-menu__exportcurves"
                type="primary"
                icon="line-chart"
                size="small"
              >
                Export Curves
              </Button> */}
            </Col>
            <Col span={8}>
              <Button
                className="sidebar-menu__usermanual"
                type="primary"
                icon="solution"
                size="small"
                disabled={!dataStore.currentDocumentationLink}
                onClick={(e) => {
                  e.preventDefault();
                  // window.open(dataStore.datasetList[dataStore.currentDataset - 1].documentationLink, "_blank");
                  window.open(dataStore.currentDocumentationLink, "_blank");
                }}
              >
                Documentation
              </Button>
            </Col>
          </Row>
          <div className="sidebar-menu__liability">
            {/*
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={
                dataStore.datasetList[dataStore.currentDataset - 1]
                  ? dataStore.datasetList[dataStore.currentDataset - 1].documentationLink
                  : '#'
              }
            >
              Documentation
            </a>
            */}

            <h4>
              Liability Claim
              {/*
              <Popover
                content={
                  <div>
                    <b>PoE:</b> Probability of Exceedance
                    <br />
                    <b>MIH:</b> Maximum Inundation Height
                    <br />
                    <b>ARP:</b> Avarage Return Period
                    <br />
                    <b>p02:</b> 2nd Percentile of the Epistemic Uncertainty
                    <br />
                    <b>p16:</b> 16th Percentile of the Epistemic Uncertainty
                    <br />
                    <b>p50:</b> 50th Percentile of the Epistemic Uncertainty
                    <br />
                    <b>p84:</b> 84th Percentile of the Epistemic Uncertainty
                    <br />
                    <b>p98:</b> 98th Percentile of the Epistemic Uncertainty
                  </div>
                }
                title="Abbreviations"
                trigger="click"
              >
                <Button style={{ float: 'right' }} size="small" type="default">
                  Abbreviations
                </Button>
              </Popover>
            */}
            </h4>
            <span style={{ fontStyle: 'italic', fontSize: 11 }}>
              {dataStore.currentLiabilityClaim
                ? dataStore.currentLiabilityClaim
                : null}
            </span>
            <h4 className="sidebar-menu__licenseTitle">License and Citation</h4>
            <Row>
              <Col span={7}>
                <a target="_blank"  rel="license" href="http://creativecommons.org/licenses/by/4.0/">
                  <img alt="Creative Commons License" src="https://i.creativecommons.org/l/by/4.0/88x31.png" />
                </a>
              </Col>
              <Col span={17} style={{ fontStyle: 'italic', fontSize: 11 }}>
                This work is licensed under a &nbsp;
                <a target="_blank" rel="license" href="http://creativecommons.org/licenses/by/4.0/">
                  Creative Commons Attribution 4.0 International License
                </a>
              </Col>
            </Row>
            <Divider />
            <Row>
              <Col span={7}>Citation:</Col>
              <Col span={17} style={{ fontStyle: 'italic', fontSize: 11 }}>
                {dataStore.currentCitation
                  ? <div dangerouslySetInnerHTML={{ __html: dataStore.currentCitation }}></div> 
                  : null}
              </Col>
            </Row>
          </div>
        </div>
      );
    }
    return null;
  }
}

export default MapMenu;



// WEBPACK FOOTER //
// ./src/components/MapMenu.js